import ErrorBoundary from "./ErrorBoundary";

function PageWrapper({ children }: { children: React.ReactNode }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}

export default PageWrapper;
